<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col  md="4" lg="3">
        <b-form-group label="Ime i prezime *">
          <b-form-input
            type="text"
            v-model="clientData.name"
            name="name">
          </b-form-input>
          <app-validation-description :show="$v.clientData.name.$dirty && $v.clientData.name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="JMBG *">
          <b-form-input
            type="text"
            v-model="clientData.jmbg"
            name="jmbg">
          </b-form-input>
          <app-validation-description :show="$v.clientData.jmbg.$dirty && $v.clientData.jmbg.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Ime jednog roditelja *">
          <b-form-input
            type="text"
            v-model="clientData.name_of_parent"
            name="name_of_parent">
          </b-form-input>
          <app-validation-description :show="$v.clientData.name_of_parent.$dirty && $v.clientData.name_of_parent.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Broj lične karte">
          <b-form-input
            type="text"
            v-model="clientData.number_of_identity_card"
            name="number_of_identity_card">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Broj pasoša">
          <b-form-input
            type="text"
            v-model="clientData.number_of_passport"
            name="number_of_passport">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Lična karta važi do">
          <date-picker name="identity_card_valid_to" v-model="clientData.identity_card_valid_to"/>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Lična karta izdata od strane">
          <b-form-input
            type="text"
            v-model="clientData.identity_card_issued_by"
            name="identity_card_issued_by">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Datum rođenja *">
          <date-picker name="date_of_birth" v-model="clientData.date_of_birth"/>
          <app-validation-description :show="$v.clientData.date_of_birth.$dirty && $v.clientData.date_of_birth.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Mjesto rođenja">
          <b-form-input
            type="text"
            v-model="clientData.place_of_birth"
            name="place_of_birth">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Država rođenja">
          <b-form-input
            v-model="clientData.country_of_birth"
            type="text"
            name="country_of_birth">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Državljanstvo">
          <b-form-input
            type="text"
            v-model="clientData.citizenship"
            name="citizenship">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Adresa (ulica i broj)">
          <b-form-input
            type="text"
            v-model="clientData.address"
            name="address">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Poštanski broj">
          <b-form-input
            v-model="clientData.zip"
            type="text"
            name="zip">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Mjesto">
          <b-form-input
            type="text"
            v-model="clientData.place"
            name="place">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Država">
          <b-form-input
            type="text"
            v-model="clientData.country"
            name="country">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Telefon">
          <b-form-input
            type="text"
            v-model="clientData.phone"
            name="phone">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Faks">
          <b-form-input
            v-model="clientData.faks"
            type="text"
            name="faks">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Email *">
          <b-form-input
            v-model="clientData.email"
            type="text"
            name="email">
          </b-form-input>
          <app-validation-description :show="$v.clientData.email.$dirty && $v.clientData.email.$invalid">
            <template v-if="!$v.clientData.email.email">
              Unesite ispravan email
            </template>
            <template v-else>
              {{$t('FIELD_MANDATORY')}}
            </template>
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Email 2">
          <b-form-input
            v-model="clientData.email2"
            type="text"
            name="email2">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Broj žiro računa">
          <b-form-input
            type="text"
            v-model="clientData.account_number"
            name="account_number">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Naziv banke">
          <b-form-input
            v-model="clientData.name_of_bank"
            type="text"
            name="name_of_bank">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Broj žiro računa 2">
          <b-form-input
            v-model="clientData.account_number2"
            type="text"
            name="account_number2">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Naziv banke 2">
          <b-form-input
            type="text"
            v-model="clientData.name_of_bank2"
            name="name_of_bank2">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <submit :loading="loading"></submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Submit from '@/components/app/AppSubmit'
import DatePicker from '@/components/app/datetime/DatePicker'
import AppValidationDescription from "@/components/app/form/AppValidationDescription";
import { required, email } from 'vuelidate/lib/validators'
import {clientMixin} from "@/mixins/client/clientMixin";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";

export default {
  name: "ClientForm",
  data() {
    return {
      clientData: {
        name: null,
        jmbg: null,
        email: null,
        email2: null,
        name_of_parent: null,
        number_of_identity_card: null,
        number_of_passport: null,
        identity_card_valid_to: null,
        identity_card_issued_by: null,
        date_of_birth: null,
        place_of_birth: null,
        country_of_birth: null,
        citizenship: null,
        address: null,
        zip: null,
        place: null,
        country: null,
        phone: null,
        faks: null,
        account_number: null,
        account_number_2: null,
        name_of_bank: null,
        name_of_bank2: null,
        type: 2
      }
    };
  },
  mixins: [clientMixin, getErrorMessage],
  validations:{
    clientData:{
      name: { required },
      jmbg: { required },
      name_of_parent: { required },
      date_of_birth: { required },
      email: { required, email },
    }
  },
  components: {
    AppValidationDescription,
    Submit,
    DatePicker
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
